import { render, staticRenderFns } from "./datAlert.vue?vue&type=template&id=709ec51e"
import script from "./datAlert.vue?vue&type=script&lang=js"
export * from "./datAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports